<template>
  <v-app v-if="isConnected">
    <v-snackbar
      v-model="snackbar.isOpened"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      top
    >
      {{ snackbar.message }}
      <v-btn
        text icon
        class="ml-4"
        color="white"
        @click="snackbar.isOpened = false"
      >
        <v-icon>clear</v-icon>
      </v-btn>
    </v-snackbar>
    <v-main>
      <topbar-indeego-settings />
      <v-container fluid class="pa-0">
        <router-view></router-view>
      </v-container>
    </v-main>
    <v-container fluid class="app-footer">
      &copy; Indeego {{ (new Date()).getFullYear() }}
    </v-container>
  </v-app>
</template>

<script>
import { mapState } from 'vuex';
import TopbarIndeegoSettings from '@/components/TopbarIndeegoSettings.vue';

export default {
  name: `LayoutApp`,

  data: () => ({
    areDatasFetched: false,
  }),

  computed: {
    ...mapState(`model/user`, [`me`]),
    ...mapState(`ui/mainLayout`, [`snackbar`]),
    isConnected() {
      return Boolean(this.me && this.me.id);
    },
  },

  async beforeMount() {
    if (!this.me || !this.me.id) {
      this.$router.replace({ name: `login` });
    }
  },

  components: {
    TopbarIndeegoSettings,
  },
};
</script>

<style lang="scss">
</style>
